<template>
  <div class="testimonial-card flex flex-col justify-between">
    <div class="stars">
      <img src="@/images/testimonials/solid-star.svg" v-for="(star, index) in testimonial.data.starsRate" :key="index" class="star-icon" />
    </div>
    <div class="testimonial-quote-container overflow-y-auto">
      <p class="testimonial-quote">{{ testimonial.data.testimonial }}</p>
    </div>
    <div class="testimonial-author">
      <img :src="testimonial.data.customerPhoto.url" :alt="`Customer ${testimonial.data.customerName} profile picture`" class="avatar" />
      <div>
        <p class="author-name">{{ testimonial.data.customerName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    testimonial: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.testimonial-card {
  min-width: 340px;
  max-width: 340px;
  height: 244px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
}

.stars {
  margin-bottom: 16px;
  color: #6366f1;
  display: flex;
}

.star-icon {
  margin-right: 4px;
}

.testimonial-author {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
}

.author-name {
  color: black;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.testimonial-quote-container {
  max-height: 140px;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #C1C1C1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #7D7D7D;
  }
}

.testimonial-quote {
  color: black;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
</style>
